import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function Home() {
  const { lang } = useLanguage();

  return (
    <>
      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            {t(lang, 'hero_badge')}
          </div>
          <h1>
            <span className="gradient-text">{t(lang, 'hero_title_1')}</span><br />
            {t(lang, 'hero_title_2')}
          </h1>
          <p>{t(lang, 'hero_text')}</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">{t(lang, 'hero_btn_contact')}</Link>
            <Link to="/about" className="btn btn-outline">{t(lang, 'hero_btn_more')}</Link>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <h2 className="section-title">{t(lang, 'services_title')}</h2>
            <p className="section-subtitle">{t(lang, 'services_subtitle')}</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4" />
                  <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" />
                </svg>
              </div>
              <h3>{t(lang, 'service_audit_title')}</h3>
              <p>{t(lang, 'service_audit_text')}</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h3>{t(lang, 'service_consulting_title')}</h3>
              <p>{t(lang, 'service_consulting_text')}</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <h3>{t(lang, 'service_info_title')}</h3>
              <p>{t(lang, 'service_info_text')}</p>
              <div className="service-links">
                <Link to="/presentations">{t(lang, 'service_info_link')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats">
            <div className="stat-item">
              <h3 className="gradient-text">20+</h3>
              <p>{t(lang, 'stat_experience')}</p>
            </div>
            <div className="stat-item">
              <h3 className="gradient-text">500+</h3>
              <p>{t(lang, 'stat_audits')}</p>
            </div>
            <div className="stat-item">
              <h3 className="gradient-text">100+</h3>
              <p>{t(lang, 'stat_clients')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <h2>{t(lang, 'cta_title')}</h2>
            <p>{t(lang, 'cta_text')}</p>
            <Link to="/contact" className="btn btn-primary">{t(lang, 'cta_btn')}</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
